<h3 class="c-stop-heading u-heading">{{ 'voyage.detailsTitle' | translate }}</h3>

<div class="c-stop-info__dates">
    <div class="c-stop-info__date c-stop-date u-text">
        @if(activePortCall()?.actualArrival){
        <h3 class="c-stop-date__title c-stop-title">{{ 'voyage.ata' | translate}}</h3>
        <p class="c-stop-date__main">{{ activePortCall()?.actualArrival | date:'dd/MM/yyyy' }} <br> {{
            activePortCall()?.actualArrival | date:'HH:mm' }} <small>(UTC-3)</small></p>
        <p class="c-stop-date__text">{{ 'voyage.eta' | translate}}: {{ activePortCall()?.estimatedArrival |
            date:'dd/MM/yyyy HH:mm' }}</p>
        } @else if(activePortCall()?.estimatedArrival){
        <h3 class="c-stop-date__title c-stop-title">{{ 'voyage.eta' | translate}}</h3>
        <p class="c-stop-date__main">{{ activePortCall()?.estimatedArrival | date:'dd/MM/yyyy' }} <br>{{
            activePortCall()?.estimatedArrival | date:'HH:mm' }} <small>(UTC-3)</small></p>
        } @else {
        <h3 class="c-stop-date__title c-stop-title">{{ 'voyage.eta' | translate}}</h3>
        <p class="c-stop-date__main">{{ 'common.na' | translate}}</p>
        }
    </div>
    <div class="c-stop-info__date c-stop-date u-text">
        @if(activePortCall()?.actualDeparture){
        <h3 class="c-stop-date__title c-stop-title">{{ 'voyage.atd' | translate}}</h3>
        <p class="c-stop-date__main">{{ activePortCall()?.actualDeparture | date:'dd/MM/yyyy' }} <br>{{
            activePortCall()?.actualDeparture | date:'HH:mm' }} <small>(UTC-3)</small></p>
        <p class="c-stop-date__text">{{ 'voyage.etd' | translate}}: {{ activePortCall()?.estimatedDeparture |
            date:'dd/MM/yyyy HH:mm' }}</p>
        } @else if(activePortCall()?.estimatedDeparture){
        <h3 class="c-stop-date__title c-stop-title">{{ 'voyage.etd' | translate}}</h3>
        <p class="c-stop-date__main">{{ activePortCall()?.estimatedDeparture | date:'dd/MM/yyyy' }} <br>{{
            activePortCall()?.estimatedDeparture | date:'HH:mm' }} <small>(UTC-3)</small></p>
        } @else {
        <h3 class="c-stop-date__title c-stop-title">{{ 'voyage.etd' | translate}}</h3>
        <p class="c-stop-date__main">{{ 'common.na' | translate}}</p>
        }
    </div>
</div>

<div class="u-push-t">
    <h3 class="c-stop-info__title c-stop-title">{{ 'voyage.portCallActivitiesTitle' | translate }}</h3>
    <ul class="c-stop-info__activities u-text">
        @if(activePortCall()?.callType == portActivityTypes.LOADING || activePortCall()?.callType ==
        portActivityTypes.BOTH || activePortCall()?.callType == portActivityTypes.ALL){
        <li class="c-stop-info__activity">
            <span class="fa-classic fa-solid fa-box-arrow-down-arrow-up"></span>
            {{ 'portActivityTypes.loading' | translate }}
        </li>
        }

        @if(activePortCall()?.callType == portActivityTypes.DISCHARGE || activePortCall()?.callType ==
        portActivityTypes.BOTH || activePortCall()?.callType == portActivityTypes.ALL){
        <li class="c-stop-info__activity">
            <span class="fa-classic fa-solid fa-box-arrow-down"></span>
            {{ 'portActivityTypes.discharge' | translate }}
        </li>
        }

        @if(activePortCall()?.callType == portActivityTypes.TECHNICAL){
        <li class="c-stop-info__activity">
            <span class="fa-classic fa-solid fa-wrench"></span>
            {{ 'portActivityTypes.technical' | translate }}
        </li>
        }

        @if(activePortCall()?.callType == portActivityTypes.BUNKER_CALL || activePortCall()?.callType ==
        portActivityTypes.ALL){
        <li class="c-stop-info__activity">
            <span class="fa-classic fa-solid fa-gas-pump"></span>
            {{ 'portActivityTypes.bunker_call' | translate }}
        </li>
        }

        @if(activePortCall()?.callType == portActivityTypes.SERVICE_CALL){
        <li class="c-stop-info__activity">
            <span class="fa-classic fa-solid fa-clipboard-list"></span>
            {{ 'portActivityTypes.service_call' | translate }}
        </li>
        }

        <!--
        <li class="c-stop-info__activity"><span class="fa-classic fa-solid fa-box-arrow-down-arrow-up"></span>
            Loading</li>
        <li class="c-stop-info__activity"><span class="fa fa-users"></span> Crew</li>
        <li class="c-stop-info__activity"><span class="fa-solid fa-box-arrow-down"></span> Discharging
        </li>
        <li class="c-stop-info__activity"><span class="fa fa-gas-pump"></span> Refuelling</li>
        <li class="c-stop-info__activity"><span class="fa fa-wrench"></span> Maintainance</li>
        <li class="c-stop-info__activity"><span class="fa-solid fa-salad"></span> Supply</li>
        <li class="c-stop-info__activity"><span class="fa fa-droplet"></span> Water</li>
         -->
    </ul>
</div>

<div class="u-push-t">
    <h3 class="c-stop-info__title c-stop-title">{{ 'voyage.stopSummaryTitle' | translate }}</h3>
    @if (appliedBerthingTypeLabel()) {
    <p class="c-kv-row">
        <span>{{ 'voyage.plannedBerthingType' | translate }}:</span>
        <span class="c-kv-row__value">{{ appliedBerthingTypeLabel() }}</span>
    </p>
    }
    @if (stayHours() != null) {
    <p class="c-kv-row">
        <span>{{ 'voyage.stayDuration' | translate }}:</span>
        <span class="c-kv-row__value">
            {{ stayHours()!.toFixed(1) }}h
            @if (stayDays() != null) {
            ({{ stayDays()!.toFixed(2) }} {{ 'pda.days' | translate }})
            }
        </span>
    </p>
    }
</div>

<div class="u-push-t">
    <h3 class="c-stop-info__title c-stop-title">{{ 'voyage.portExpensesTitle' | translate }}</h3>
    <p class="c-kv-row">
        <span>{{ 'voyage.fuelConsumption' | translate}}:</span>
        <span class="c-kv-row__value">${{ activeExpenses()?.fuel_cost_from_last_port_usd ?? '0.00' }}</span>
    </p>
    <p class="c-kv-row">
        <span>{{ 'voyage.pdaEstimatedCost' | translate }}:</span>
        @if (activePda(); as pda) {
        <span class="c-kv-row__value">${{ pda.totalUsd ?? '0.00' }}</span>
        <span class="c-tag context:{{ pdaStatusContext() }}">{{ ('pda.status.' + pda.status) | translate }}</span>
        @if (pda.calculatedAt) {
        <span class="c-kv-row__sub">{{ 'voyage.pdaCalculatedAt' | translate }}: {{ pda.calculatedAt |
            date:'dd/MM/yyyy HH:mm' }}</span>
        }
        } @else {
        <span class="c-kv-row__value">{{ 'voyage.pdaNotCalculated' | translate }}</span>
        }
    </p>
</div>

@if (activePortCall()?.overtimeSnapshot) {
<div class="u-push-t">
    <h3 class="c-stop-info__title c-stop-title">{{ 'voyage.overtimeTitle' | translate }}</h3>
    <app-voyage-overtime-summary [overtimeSnapshot]="activePortCall()!.overtimeSnapshot ?? null" />
</div>
}
<div>
    <button type="button" class="c-link u-push-t" (click)="onViewPdaBreakdown()">
        {{ 'voyage.viewPdaBreakdown' | translate }}
    </button>
</div>

<div class="c-stop-info__actions u-push-t--xl u-flex--wrap">
    <button type="button" class="c-stop-info__action c-btn" [disabled]="activePortCall()?.actualArrival"
        (click)="onArrival()">
        <span class="fa-solid fa-box-arrow-down-arrow-up"></span>
        {{ 'voyage.arrivalDateBtn' | translate }}
    </button>
    <button type="button" class="c-stop-info__action c-btn"
        [disabled]="activePortCall()?.actualDeparture || !activePortCall()?.actualArrival" (click)="onDeparture()">
        <span class="fa-classic fa-solid fa-box-arrow-down"></span>
        {{ 'voyage.departureDateBtn' | translate }}
    </button>
</div>